import React, { useState, createContext, useContext } from 'react';
import AddedProductsMessage from './AddedProductsMessage';

const MESSAGES_TYPES = {
    ADDED_PRODUCT_MESSAGE: 'addedProductsMessage',
};

const MESSAGES_COMPONENTS = {
    [MESSAGES_TYPES.ADDED_PRODUCT_MESSAGE]: AddedProductsMessage,
};

const MessagesContext = createContext({});
const useMessagesContext = () => useContext(MessagesContext);

const MessagesContextProvider = ({ children }) => {
    const [store, setStore] = useState({
        messageType: '',
        messageProps: {},
    });
    const { messageType, messageProps } = store;

    const showMessage = (messageType, messageProps) => {
        setStore({
            ...store,
            messageType,
            messageProps,
        });
    };

    const hideMessage = () => {
        setStore({
            ...store,
            messageType: '',
            messageProps: {},
        });
    };

    const renderComponent = () => {
        const MessagesComponent = MESSAGES_COMPONENTS[messageType];

        if (!messageType || !MessagesComponent) {
            return null;
        }

        return <MessagesComponent {...messageProps} />;
    };

    return (
        <MessagesContext.Provider value={{ store, showMessage, hideMessage, MESSAGES_TYPES }}>
            {renderComponent()}
            {children}
        </MessagesContext.Provider>
    )
};

export { useMessagesContext };

export default MessagesContextProvider;
